import { jsx as _jsx } from "react/jsx-runtime";
import { StatusBadge } from '@src/components/ui';
import { getBooleanStatusBadgeColors } from '../utils/formatters';
const createdAtFormatter = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
});
export const createCorporateGroupColumns = () => [
    {
        key: 'name',
        header: 'Name',
        sortable: true,
        render: (group) => group.name || 'N/A',
    },
    {
        key: 'abbreviation',
        header: 'Abbreviation',
        sortable: true,
        render: (group) => group.abbreviation || 'N/A',
    },
    {
        key: 'corporate_membership_id',
        header: 'Membership ID',
        sortable: true,
        render: (group) => String(group.corporate_membership_id || 'N/A'),
    },
    {
        key: 'discount_percentage',
        header: 'Discount %',
        sortable: true,
        render: (group) => {
            const value = Number(group.discount_percentage || 0);
            return `${value.toFixed(2)}%`;
        },
    },
    {
        key: 'is_active',
        header: 'Active',
        sortable: true,
        render: (group) => {
            const label = group.is_active ? 'Active' : 'Inactive';
            const { background, text } = getBooleanStatusBadgeColors(!!group.is_active);
            return (_jsx(StatusBadge, { label: label, bgColor: background, color: text }));
        },
    },
    {
        key: 'created_at',
        header: 'Created At',
        sortable: true,
        render: (group) => {
            if (group.created_at_display)
                return group.created_at_display;
            if (!group.created_at)
                return 'N/A';
            return createdAtFormatter.format(new Date(group.created_at));
        },
    },
];
